import { useState, useEffect, useMemo, useRef } from "react"
import { toast } from "sonner"
import { useGetRequest } from "../../Utils/hooks/QueryHandler"
import {
  GetRequest,
  DeleteRequest,
  PostRequest,
} from "../../Utils/hooks/ApiHandler"
import {
  IconColumns3,
  IconInfoCircle,
  IconLayoutGrid,
  IconListDetails,
} from "@tabler/icons-react"
import { baseURL } from "../../Utils/constants/constant"
import EditCompanyOffcanvas from "../../pages/EditCompanyOffcanvas"
import DeleteModal from "../DeleteModal"
import { useNavigate } from "react-router-dom"
import profile from "../../Utils/assets/img/profile.jpg"

import imges from "../../Utils/assets/img/chart/card-1.png"
import {
  checkTwilioIntegration,
  getColCount,
  maskContactNumber,
  PaginationButtons,
} from "../../Utils/helpers/commonhelper"
import {
  Button,
  Col,
  Container,
  Dropdown,
  Form,
  Nav,
  OverlayTrigger,
  Row,
  Table,
  Tooltip,
} from "react-bootstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faCalendar,
  faCalendarDay,
  faEllipsisVertical,
  faFileExport,
  faFileImport,
  faGear,
  faUser,
  faUserPlus,
  faPlus,
  faPhone,
} from "@fortawesome/free-solid-svg-icons"
import { Pagination } from "../../pages/Pagination"
import { Filter } from "../../pages/Filter"
import { CompanyDetails } from "../detailPage/CompanyDetails"
import {
  getAllCities,
  getAllStates,
  getCountries,
} from "../../Utils/hooks/location"
import { DropdownItemWithActions } from "../../pages/DropdownItemWithActions"
import { CompanyCardView } from "../../pages/CompanyCardView"
import { CPopover, CButton } from "@coreui/react"
import { FilterPagination } from "../../pages/FIlterPagination"
import useLocalStorageState from "use-local-storage-state"
import { ExportDataPopup } from "../../pages/ExportDataPopup"
import nodata from "../../Utils/assets/img/leads_no_data_found.png"
import { AuthorizationCard } from "../../pages/AuthorizationCard"
import {
  ResponsiveContainer,
  XAxis,
  YAxis,
  CartesianGrid,
  Line,
  Area,
  ComposedChart,
  Tooltip as RechartTooltip
} from "recharts"
import { CompanyCardSkeletonShimmer } from "../../Utils/skeletonLoader/CompanyCardSkeletonShimmer"
import { TableSkeleton } from './../../Utils/skeletonLoader/TableSkeleton';
import { DraggableColumnList } from "../../pages/DraggableColumnList"
import { ColumnConfigurator } from "../../pages/ColumnConfigurator"
import GlobalCallModal from "../ivr/GlobalCallModal"
import TwilioIntegrationForm from "../ivr/TwilioIntegrationForm##"
import { ManageListDropdown } from "../../pages/ManageListDropdown"

const customStylesForPopover = {
  "--cui-popover-min-width": "400px",
  "--cui-popover-header-color": "var(--cui-white)",
  "--cui-popover-body-padding-x": "1rem",
  "--cui-popover-body-padding-y": ".5rem",
}


export const EditCompanies = ({ reloadKey, setShowCreateCompany, highlightId }) => {
  const industryOptions = [
    { value: "Technology", label: "Technology" },
    { value: "Healthcare", label: "Healthcare" },
    { value: "Finance", label: "Finance" },
    { value: "Education", label: "Education" },
    { value: "Manufacturing", label: "Manufacturing" },
    { value: "Retail", label: "Retail" },
    { value: "Real Estate", label: "Real Estate" },
    { value: "Construction", label: "Construction" },
    { value: "Transportation", label: "Transportation" },
    { value: "Food & Beverage", label: "Food & Beverage" },
    { value: "Entertainment", label: "Entertainment" },
    { value: "Consulting", label: "Consulting" },
    { value: "Marketing & Advertising", label: "Marketing & Advertising" },
    { value: "Legal Services", label: "Legal Services" },
    { value: "Insurance", label: "Insurance" },
    { value: "Telecommunications", label: "Telecommunications" },
    { value: "Energy", label: "Energy" },
    { value: "Agriculture", label: "Agriculture" },
    { value: "Automotive", label: "Automotive" },
    { value: "Aerospace", label: "Aerospace" },
    { value: "Pharmaceuticals", label: "Pharmaceuticals" },
    { value: "Banking", label: "Banking" },
    { value: "E-commerce", label: "E-commerce" },
    { value: "Media", label: "Media" },
    { value: "Non-profit", label: "Non-profit" },
    { value: "Government", label: "Government" },
    { value: "Hospitality", label: "Hospitality" },
    { value: "Travel & Tourism", label: "Travel & Tourism" },
    { value: "Sports & Recreation", label: "Sports & Recreation" },
    { value: "Beauty & Wellness", label: "Beauty & Wellness" },
  ]

  const businessTypeOptions = [
    { value: "Sole Proprietorship", label: "Sole Proprietorship" },
    {
      value: "Limited Liability Partnership(LLP)",
      label: "Limited Liability Partnership(LLP)",
    },
    { value: "Private Limited Company", label: "Private Limited Company" },
    { value: "Public Limited Company", label: "Public Limited Company" },
  ]

  const employeeSizeOptions = [
    { value: "1-10", label: "1-10" },
    { value: "11-50", label: "11-50" },
    { value: "51-200", label: "51-200" },
    { value: "201-500", label: "201-500" },
    { value: "501-1000", label: "501-1000" },
    { value: "1001+", label: "1001+" },
  ]

  // Column options configuration - keep for settings dropdown
  const columnOptions = [
    { id: "name", label: "Name", mandatory: true },
    // { id: "website", label: "Website" },
    { id: "industry", label: "Industry" },
    { id: "business_type", label: "Business Type" },
    { id: "owner", label: "Owner" },
    { id: "phone", label: "Contact No." },
    { id: "email", label: "Email" },
    { id: "address", label: "Address" },
    { id: "state", label: "State" },
    { id: "city", label: "City" },
    { id: "zipcode", label: "Zipcode" },
  ]

  const [showCompanyDetails, setShowCompanyDetails] = useState(false)
  // delete state for filter
  const [confirmFilterDelete, setFilterDelete] = useState(false)
  const [selectedCompanyId, setSelectedCompanyId] = useState(null)
  const [activeCard, setActiveCard] = useState(null)
  const [editValue, setEditValue] = useState()
  // states to store the filter data
  const [filterStates, setFilterState] = useState([])
  const [confirmDeleteId, setConfirmDeleteId] = useState(null)
  const [editCompanyId, setEditCompanyId] = useState(null)
  const [companyData, setCompanyData] = useState(null)
  const [showOffcanvas, setShowOffcanvas] = useState(false)

  const [tableOffset, setTableOffset] = useState(0)
  const [cardOffset, setCardOffset] = useState(0)

  const [viewMode, setViewMode] = useState("Table")
  const activeOffset = viewMode === "card" ? cardOffset : tableOffset
  const setActiveOffset =
    viewMode === "card" ? setCardOffset : setTableOffset
  const [pageButtons, setPageButtons] = useState([])
  const [search, setSearch] = useState()
  const [inputSearch, setInputSearch] = useState("")
  const Limit = viewMode === "card" ? 24 : 25
  const [limit, setLimit] = useState(Limit)
  const [companies, setCompanies] = useState([])
  const [filterCategories, setFilterCategories] = useState([])
  // filter state to store the data to pass to delete and edit handler for filter
  const [filterData, setFilterData] = useState(null)
  const lastHeading = localStorage.getItem("company_last_heading")
  const [heading, setHeading] = useState("All Companies")
  const [filterLimit, setFilterLimit] = useState(5)
  const [openRow, setOpenRow] = useState(null)
  const [filterPageCount, setFilterPageCount] = useState(0)
  const [debouncedFilterSearch, setDebouncedFilterSearch] = useState("")
  const [isOwnerSame, setIsOwnerSame] = useState(false)
  // delete modal loading state
  const [loading, setLoading] = useState(false)
  // checking and validating if the last selected filter still exist until then the state initialized would be false and no data or the heading would be renderd
  const [isInitialized, setIsInitialized] = useState(false)

  const [isCheckingTwilio, setIsCheckingTwilio] = useState(false);
  const [globalDiller, setGlobalDiller] = useState(false);
  const [showtwilioModal, setShowTwilioModal] = useState(false);
  const [module_id, setModuleId] = useState(null);
  const [callingTo, setCallingTo] = useState(null)

  const handleViewChange = (mode) => {
    setViewMode(mode)
    localStorage.setItem("company_list_view", mode)

    const newLimit = mode === "card" ? 24 : 25
    setLimit(newLimit)
  }
  console.log("viewMode", viewMode)
  useEffect(() => {
    const savedView = localStorage.getItem("company_list_view")

    if (savedView) {
      setViewMode(savedView)
      // Sync the limit with the saved view
      setLimit(savedView === "card" ? 24 : 25)
    }
  }, [])
  useEffect(() => {
    if (filterCategories.length > 0 && !isInitialized) {
      const lastHeading = localStorage.getItem("company_last_heading")
      const existingFilter = filterCategories.find(
        (filter) => filter.card_name === lastHeading
      )
      setHeading(existingFilter ? lastHeading : "All Companies")
      setIsInitialized(true)
    }
  }, [filterCategories, isInitialized])

  const [refetchCall, setRefetchCall] = useState(false)
  // states for dynamic api calls
  const [endpoint, setEndpoint] = useState()
  const [queryKey, setQueryKey] = useState()
  const [showCards, setShowCards] = useState(true)
  // all states for filter field hydration
  const [allState, setAllState] = useState([])
  const [leadOwner, setLeadOwner] = useState([])
  // all cities for filter field hydration
  const [allCity, setAllCity] = useState([])
  // country state
  const [country, setCountries] = useState([])
  // Initialize columns state from localStorage or default to all visible
  const [columns, setColumns] = useState(() => {
    const saved = localStorage.getItem("visibleCompanyColumns");
    const allColumnKeys = columnOptions.map(col => col.label);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        console.error("Error parsing visible columns:", e);
      }
    }
    return allColumnKeys;
  });

  const [filterDropdown, setFilterDropdown] = useState(false)
  const [tempFilterData, setTempFilterData] = useState(null)

  const [cardData, setCardData] = useState(null);

  const [customer, setCustomer] = useLocalStorageState("customer", {
    token: {},
  })
  const customer_id = customer?.customer_details?.customer_id;
  const user_login_id = customer?.customer_details?.id;
  const token = customer?.token?.authorization || ""
  const rf = customer?.token?.authentication || ""
  const headers = { Authorization: token, Authentication: rf }
  const navigate = useNavigate()
  const extras = { customer, setCustomer, rf, navigate }
  const params = useMemo(
    () => ({ limit, offset: activeOffset, search }),
    [limit, activeOffset, search]
  )
  const [filterOffset, setFilterOffset] = useState(0)
  const [showColumnsDropdown, setShowColumnsDropdown] = useState(false)
  const [filterSearchInput, setFilterSearchInput] = useState("")
  // Updated dataToDisplay logic
  const dataToDisplay = tempFilterData !== null ? tempFilterData : companies
  const hasDataToDisplay = dataToDisplay?.length > 0
  // export popup state
  const [exportPop, setExportPop] = useState(false)

  // permission setup for company
  const permission = customer.customer_details?.permission
  // company permissions while creating contact
  const companyPermission = permission?.filter(c => c.module_name === "company")
  const user_type = Number(customer.customer_details?.user_type)
  const companyGrants = {
    isView: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "company")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "company")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "company")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "company")?.delete)) : true,
    isImport: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "import")?.is_action)) : true,
    isExport: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "export")?.is_action)) : true,
  }

  // Fixed dropdown options for filtering (matches hardcoded table columns)
  const dropdownOptions = [
    { value: "company_name", label: "Company Name" },
    { value: "website", label: "Website" },
    { value: "industry", label: "Industry", option: industryOptions },
    {
      value: "business_type",
      label: "Business Type",
      option: businessTypeOptions,
    },
    { value: "owner_id", label: "Owner", option: leadOwner },
    { value: "email", label: "Email" },
    { value: "address", label: "Address" },
    { value: "state", label: "State", option: allState },
    { value: "city", label: "City", option: allCity },
    { value: "zipcode", label: "Zipcode" },
    { value: "phone", label: "Phone" },
    { value: "country", label: "Country", option: country },
    {
      value: "employee_size",
      label: "Employee Size",
      option: employeeSizeOptions,
    },
    { value: "status", label: "Status" },
    { value: "rating", label: "Rating" },
    { value: "created_at", label: "Created at", type: "date-range" },
  ]

  const subFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "contains", label: "Contains" },
    { value: "not_contains", label: "Not-Contains" },
    { value: "in", label: "In" },
    { value: "not_in", label: "Not-In" },
    { value: "is_empty", label: "Is Empty" },
    { value: "is_not_empty", label: "Is Not Empty" },
    { value: "begins_with", label: "Begins With" },
    { value: "between", label: "Between" },
  ]

  const customSubFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "is_set", label: "Is Set" },
    { value: "is_not_set", label: "Is Not Set" },
    { value: "in", label: "In" },
    { value: "not_in", label: "Not-In" },
  ]

  const companyStaticListOptions = [
    {
      key: "All Companies",
      icon: <FontAwesomeIcon
        icon={faUser}
        style={{ width: "13px", height: "13px", marginRight: "9px" }}
      />
    },
    {
      key: "Companies Created By Me",
      icon: <FontAwesomeIcon
        icon={faUserPlus}
        style={{ width: "15px", height: "15px", marginRight: "9px" }}
      />
    },
    {
      key: "Companies Created Today",
      icon: <FontAwesomeIcon
        icon={faCalendarDay}
        style={{ width: "13px", height: "13px", marginRight: "9px" }}
      />
    },
    {
      key: "Companies Created this Month",
      icon: <FontAwesomeIcon
        icon={faCalendar}
        style={{ width: "13px", height: "13px", marginRight: "9px" }}
      />
    },
  ]

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedFilterSearch(filterSearchInput)
      setFilterOffset(0) // Reset to first page when search changes
    }, 300)

    return () => clearTimeout(timer)
  }, [filterSearchInput])

  // Helper functions for column filtering
  const getColumnData = (company, columnId, index) => {
    const { primaryEmail } = renderCompanyRow(company, index)

    const columnMap = {
      "#": index + 1 + activeOffset * limit,
      name: company.company_name || "-",
      website: company.website || "-",
      industry: company.industry || "-",
      business_type: company.business_type || "-",
      owner: company.owner_name || "-",
      email: primaryEmail || "-",
      address: company.address || "-",
      state: company.state_name || "-",
      city: company.city_name !== null ? company.city_name : "-",
      zipcode: company.zipcode || "-",
    }

    return columnMap[columnId] || "-"
  }

  const getCountryCode = (company) => {
    try {
      const phoneData = JSON.parse(company.user_phone)
      return phoneData[0]?.country_code ? `${phoneData[0].country_code}` : ""
    } catch {
      return ""
    }
  }


  const getColumnStyle = (columnId) => {
    switch (columnId) {
      case "name":
        return { fontWeight: 600, color: "inherit" }
      case "email":
        return { color: "#2184ff" }
      case "industry":
        return { color: "#2184ff" }
      case "phone":
        return { color: "#2184ff" };
      default:
        return {}
    }
  }

  const ownerColorMap = {}
  const handleFilterPageChange = (newOffset) => {
    setFilterOffset(newOffset.selected)
  }

  const getColumnContent = (company, columnId, index) => {
    const data = getColumnData(company, columnId, index)
    const { primaryEmail } = renderCompanyRow(company, index)
    const tooltip = <Tooltip id="tooltip">{company?.website ?? "-"}</Tooltip>

    const tooltips = <Tooltip id="tooltip">{data}</Tooltip>
    const addressTooltip = <Tooltip id="tooltip">{data}</Tooltip>

    switch (columnId) {
      case "name":
        return (
          <div className="d-flex align-items-center gap-1">
            {company?.website !== null ? (
              <a
                href={
                  company?.website ??
                  (company?.website?.startsWith("http")
                    ? company?.website
                    : `https://${company?.website}`)
                }
                target="_blank"
                rel="noopener noreferrer"
                className="me-2"
              >
                <OverlayTrigger placement="top" overlay={tooltip}>
                  <i className="bi bi-globe"></i>
                </OverlayTrigger>
              </a>
            ) : (
              <i
                className="bi bi-globe me-2"
                style={{ color: "#4b4f56b8" }}
              ></i>
            )}

            <div
              onClick={(e) => {
                e.preventDefault()
                setSelectedCompanyId(company.id)
                setShowCompanyDetails(true)
              }}
              style={{ color: "inherit", textDecoration: "none" }}
            >
              {data?.length > 30 ? (
                <OverlayTrigger placement="top" overlay={tooltips}>
                  <span>{`${data.slice(0, 20)}...`}</span>
                </OverlayTrigger>
              ) : (
                data
              )}
            </div>
          </div>
        )
      case "email":
        return primaryEmail ? (
          <a href={`mailto:${primaryEmail}`}>
            <i className="fa-solid fa-envelope me-1"></i> {primaryEmail}
          </a>
        ) : (
          "-"
        )
      case "phone": {
        const phoneArray = company?.user_phone
          ? JSON.parse(company.user_phone)
          : [];
        const firstEntry = phoneArray[0];
        return firstEntry ? (
          <span
            style={{ cursor: "pointer", color: "#2184ff" }}
            disabled={isCheckingTwilio}
            onClick={() => {
              !showtwilioModal && setModuleId(company?.id)
              setCallingTo(`${firstEntry.country_code} ${firstEntry.phone
                }`)
              checkTwilio()
            }}
          ><FontAwesomeIcon icon={faPhone} />{`${firstEntry.country_code} ${maskContactNumber(firstEntry.phone)}`}</span>
        ) : (
          "-"
        );
      }
      case "industry":
        return company.industry ? (
          <CPopover
            className=""
            placement="right"
            style={customStylesForPopover}
            trigger="hover" // opens on hover
            content={
              <div>
                <div className="row header border-bottom m-0 pb-3">
                  <div className="name d-flex gap-3 rounded align-items-center pr-0">
                    <div className="avatarDivs">
                      <span>
                        {company?.company_name
                          .split(" ")
                          .map((word) => word[0])
                          .join("")
                          .toUpperCase()}
                      </span>
                    </div>

                    <div
                      className="link-primary text-break "
                      style={{ fontSize: "14px", fontWeight: "600" }}
                    >
                      {company.company_name}
                      (#00964854){" "}
                    </div>
                  </div>
                </div>

                <div className="content">
                  <div className="row w-100 ms-0 mt-3 m-0 border-bottom pb-3">
                    <div className="col-6 read-only-info p-0 ml-0 mr-0 mb-2">
                      <div className="label">Company name</div>
                      <div className="title text-truncate">
                        <div
                          className="text-truncate"
                          data-toggle="tooltip"
                          title=""
                        >
                          {company.company_name}
                        </div>
                      </div>
                    </div>
                    <div className="col-6 read-only-info p-0 ml-0 mr-0">
                      <div className="label">Industry</div>
                      <div className="title text-truncate">
                        <div className="text-truncate" title="">
                          {company.industry}{" "}
                        </div>
                      </div>
                    </div>
                    <div className="col-6 read-only-info p-0 ml-0 mr-0 mb-2">
                      <div className="label">City</div>
                      <div className="title text-truncate">
                        <div className="text-truncate" title="">
                          {company.city_name}
                        </div>
                      </div>
                    </div>
                    <div className="col-6 read-only-info p-0 ml-0 mr-0 mb-2">
                      <div className="label">Country</div>
                      <div className="title text-truncate">
                        <div title="No">{company.country_name || "India"}</div>
                      </div>
                    </div>
                    <div className="col-6 read-only-info p-0 ml-0 mr-0 mb-2">
                      <div className="label">Owner</div>
                      <div className="title text-truncate">
                        <div
                          className="text-truncate"
                          data-toggle="tooltip"
                          title=""
                        >
                          {company.owner_name}
                        </div>
                      </div>
                    </div>
                    <div className="col-6 read-only-info p-0 ml-0 mr-0">
                      <div className="label">Academic Year</div>
                      <div className="title text-truncate">
                        <div className="text-truncate" title="">
                          2025 Mar - 2026 Feb{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-3 pb-3 w-100 ms-0">
                    <div className="phone-numbers col-md-6">
                      <div className=" read-only-info p-0 ml-0 mr-0">
                        <div className="label">Company No</div>
                        <div className="title text-truncate">
                          <div title=" 8855669955">
                            <i
                              className="fa-solid fa-phone-volume"
                              style={{
                                color: "#0250d9",
                                fontSize: 12,
                                marginRight: 6,
                              }}
                            ></i>
                            {/* {company.phone} */}
                            <span
                              style={{
                                letterSpacing: "0.25px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {`${getCountryCode(company)} ${maskContactNumber(company.phone)}`}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="emails col-md-6">
                      <div className=" read-only-info p-0 ml-0 mr-0">
                        <div className="label">Company Email</div>
                        <div className="title text-truncate">
                          <div title=" akash@gmail.com">
                            <i
                              className="fa-solid fa-envelope"
                              style={{
                                color: "#0250d9",
                                fontSize: 14,
                                marginRight: 6,
                              }}
                            ></i>{" "}
                            {company.email}{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          >
            <CButton color="none" size="lg">
              {company.industry || "-"}
            </CButton>
          </CPopover>
        ) : (
          "-"
        )

      case "owner": {
        const getRandomColor = () => {
          const hue = Math.floor(Math.random() * 360)
          const saturation = 45 + Math.random() * 10
          const lightness = 70 + Math.random() * 10
          return `hsl(${hue}, ${saturation}%, ${lightness}%)`
        }

        const getColorForOwner = (name) => {
          if (!name) return "#d6d6d6"

          if (ownerColorMap[name]) return ownerColorMap[name]

          let newColor
          do {
            newColor = getRandomColor()
          } while (Object.values(ownerColorMap).includes(newColor))

          ownerColorMap[name] = newColor
          return newColor
        }

        const pillColor = getColorForOwner(company.owner_name)

        return (
          <span
            style={{
              display: "inline-block",
              backgroundColor: pillColor,
              color: "#3f3d3d",
              padding: "1px 8px 2px",

              borderRadius: "20px",
              fontSize: "11px",
              fontWeight: "400",
              textTransform: "capitalize",
            }}
          >
            {company.owner_name || "N/A"}
          </span>
        )
      }
      case "address": {
        return (
          <>
            <OverlayTrigger placement="top" overlay={addressTooltip}>
              <span>
                {company.address?.length > 20
                  ? `${company?.address.slice(0, 20)}...`
                  : company.address}
              </span>
            </OverlayTrigger>
          </>
        )
      }

      default:
        return data
    }
  }

  // useeffect for country
  useEffect(() => {
    ; (async () => {
      try {
        const data = await getCountries()
        if (!data) return
        // Update state once with all country data
        setCountries(
          data.map((country) => ({
            countryName: country.name,
            countryId: country.id,
          }))
        )
      } catch (error) {
        toast.error("Error Fetching Data")
        return
      }
    })()
  }, [])

  //  allFstate for filter hydration
  useEffect(() => {
    ; (async () => {
      try {
        const data = await getAllStates()
        if (!data || data === undefined) {
          setAllState([])
          return
        }
        // // Update state once with all country data
        setAllState(
          data.map((state) => ({
            stateName: state.state_name,
            stateCode: state.id,
          }))
        )
      } catch (error) {
        toast.error("Error Fetching State")
        return
      }
    })()
  }, [])

  // allcity useeffect for filter hydration
  useEffect(() => {
    ; (async () => {
      try {
        const data = await getAllCities()
        if (!data || data === undefined) {
          setAllCity([])
          return
        }
        //Update state once with all country data
        setAllCity(
          data.map((city) => ({
            cityName: city.city_name,
            cityCode: city.id,
          }))
        )
      } catch (error) {
        toast.error("Error Fetching State")
        return
      }
    })()
  }, [])

  useEffect(() => {
    ; (async () => {
      const res = await GetRequest(
        `users/users/fetchUserAsOwner/${customer.customer_details.customer_id}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      )
      // Update state once with all new leads
      setLeadOwner(
        res.data.map((lead) => ({
          leadName: lead.full_name,
          leadId: lead.id,
        }))
      )
      if (res.err) {
        toast.error("Error Fetching Data")
      }
    })()
  }, [])

  useEffect(() => {
    ; (async () => {
      try {
        const res = await GetRequest(
          `company/fetchFilterCards/${customer.customer_details?.customer_id}?offset=${filterOffset}&limit=${filterLimit}&search=${debouncedFilterSearch}`,
          { headers },
          { customer, setCustomer, rf: headers.Authentication, navigate }
        )

        if (res.status === "fail" || res.success === false) {
          // toast.error(res.message)
          return
        }
        setFilterCategories(res.data)
        // Calculate page count if total_count is available in response
        if (res.total_count) {
          setFilterPageCount(Math.ceil(res.total_count / filterLimit))
        }
      } catch (error) {
        // toast.error()
        return
      }
    })()
  }, [
    heading,
    customer,
    lastHeading,
    refetchCall,
    filterOffset,
    filterLimit,
    debouncedFilterSearch,
  ])

  useEffect(() => {
    const lowerHeading = heading.toLowerCase()?.split(" ").join("_")
    if (lowerHeading === "companies_created_by_me") {
      setEndpoint(
        `company/getCompanyCreatedByMe/${customer.customer_details?.id}/${customer.customer_details?.customer_id}`
      )
      setQueryKey("companiesCreatedByMe")
    } else if (lowerHeading === "companies_created_today") {
      setEndpoint(
        `company/getCompanyCreatedBasedOnDuration/${customer.customer_details?.id}/${customer.customer_details?.customer_id}/today`
      )
      setQueryKey("companiesCreatedToday")
    } else if (lowerHeading === "companies_created_this_month") {
      setEndpoint(
        `company/getCompanyCreatedBasedOnDuration/${customer.customer_details?.id}/${customer.customer_details?.customer_id}/month`
      )
      setQueryKey("companiesCreatedThisMonth")
    } else if (lowerHeading === "all_companies" || lowerHeading === null) {
      setEndpoint(
        `company/fetchAllCompanies/${customer.customer_details?.customer_id}`
      )
      setQueryKey("fetchAllCompanies")
    } else {
      const matchedCategory = filterCategories.find((category) => {
        return category.card_name === heading
      })
      if (matchedCategory) {
        setEndpoint(
          `company/fetchAllCompanies/${customer.customer_details?.customer_id}/${matchedCategory.id}`
        )
        setQueryKey(
          `filterQuery${matchedCategory.card_name
            .toLowerCase()
            ?.split(" ")
            .join("_")}`
        )
      }
    }
  }, [heading, filterCategories])

  const { data, error, refetch, isLoading } = useGetRequest(
    endpoint,
    queryKey,
    headers,
    { customer, setCustomer, rf: headers.Authentication, navigate },
    params
  )

  useEffect(() => {
    if (
      data &&
      data.filter_data &&
      data.filter_data[0] &&
      data.filter_data[0].filter_values
    ) {
      const values = data.filter_data[0].filter_values
      const parsedState = JSON.parse(values)
      const filteredArray = parsedState?.map((state) => {
        // Find the corresponding dropdown option to get the display label and potential nested options
        const dropdownOption = dropdownOptions.find(
          (opt) => opt.value === state.label_name
        )

        let mappedOptions = null
        if (dropdownOption?.option && Array.isArray(dropdownOption.option)) {
          // Replicate the mapping logic from handleAddFilter
          if (dropdownOption.value === "owner_id") {
            mappedOptions = dropdownOption.option.map((opt) => ({
              value: opt.leadId,
              label: opt.leadName,
            }))
          } else if (dropdownOption.value === "lead_source_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.lead_source_id,
              label: opt.source_title,
            }))
          } else if (dropdownOption.value === "company_id") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.company_id,
              label: opt.company_name,
            }))
          } else if (dropdownOption.value === "country") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.countryId,
              label: opt.countryName,
            }))
          } else if (dropdownOption.value === "state") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.stateCode,
              label: opt.stateName,
            }))
          } else if (dropdownOption.value === "city") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.cityId,
              label: opt.cityName,
            }))
          } else if (dropdownOption.value === "industry") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.value,
              label: opt.label,
            }))
          } else if (dropdownOption.value === "business_type") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.value,
              label: opt.label,
            }))
          } else if (dropdownOption.value === "employee_size") {
            mappedOptions = dropdownOption.option?.map((opt) => ({
              value: opt.value,
              label: opt.label,
            }))
          }
        }
        return {
          id: state.label_name, // IMPORTANT: Generate a new unique ID for React keys
          field: state.label_name, // This is the internal identifier (e.g., "email", "owner")
          label_name: dropdownOption ? dropdownOption.label : state.label_name,
          option: mappedOptions,
          subFilterType: state.label_query,
          value: state.label_value,
        }
      })
      setFilterState(filteredArray)
    } else {
      setFilterState([])
    }
  }, [queryKey, data])

  // Calculate total pages based on dataToDisplay
  // const pageCount = Math.ceil(
  //   (tempFilterData ? tempFilterData.length : data?.total_count || 0) / limit
  // )
  const isFiltered = tempFilterData !== null

  const pageCount = Math.ceil(
    (isFiltered ? (tempFilterData?.length || 0) : (data?.total_count || 0)) / limit
  )

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setSearch(inputSearch.trim())
      setActiveOffset(0)
    }, 300)

    return () => clearTimeout(debounceTimer)
  }, [inputSearch])

  useEffect(() => {
    refetch()
  }, [reloadKey])

  useEffect(() => {
    if (data?.data) {
      setCompanies(data.data)
      setPageButtons(PaginationButtons(data.total_count || 0, limit))
    }
  }, [data, limit])

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        !event.target.closest("[data-dropdown]") &&
        !event.target.closest("[data-options-button]")
      ) {
        setActiveCard(null)
      }
    }
    document.addEventListener("click", handleClickOutside)
    return () => document.removeEventListener("click", handleClickOutside)
  }, [])

  const handleSearch = (e) => {
    e.preventDefault()
    setSearch(inputSearch)
    setActiveOffset(0)
  }


  const fetchCompanyDetails = async (id) => {
    try {
      const res = await GetRequest(
        `company/getCompanyDetails/${id}`,
        { headers },
        extras
      )
      if (res?.status === "success") {

        if (
          customer?.customer_details?.user_type === "1"
        ) {
          setIsOwnerSame(true)
        } else if (user_login_id === res?.data[0]?.owner_id) {
          setIsOwnerSame(true)
        } else {
          setIsOwnerSame(false)
        }

        if (
          customer?.customer_details?.user_type === "1"
        ) {
          setIsOwnerSame(true)
        } else if (user_login_id === res?.data[0]?.owner_id) {
          setIsOwnerSame(true)
        } else {
          setIsOwnerSame(false)
        }
        setCompanyData(res.data[0])
        setEditCompanyId(id)
        setShowOffcanvas(true)
      } else {
        toast.error("Failed to fetch company details")
      }
    } catch {
      toast.error("Something went wrong")
    }
  }

  //!-------------------------------------------------

  const getCardContent = async () => {
    try {
      const res = await GetRequest(
        `company/companyCard/${customer_id}/${user_login_id}`,
        { headers },
        extras
      )
      if (res?.status === 'success') {
        setCardData(res.data)
      } else {
        toast.error("failed to get card details")
      }
    } catch (error) {
      toast.error("Something went wrong")
    }
  }

  useEffect(() => {
    getCardContent();
  }, []);


  const top10CitiesData = cardData?.cities
    ?.filter(c => c.city_name)       // remove null cities
    ?.slice(0, 10)                   // top 10
    ?.map(c => ({
      city: c.city_name.length > 6
        ? c.city_name.slice(0, 6) + "…"
        : c.city_name,
      companies: c.company,
    }));


  const handleDeleteCompany = async (id) => {
    setLoading(true)
    try {
      const res = await DeleteRequest(
        `company/deleteCompany/${id}`,
        { headers },
        extras
      )
      //  Always close the popup
      setConfirmDeleteId(null)

      if (res?.success || res?.status === "success") {
        setLoading(false)
        toast.success(res.message || "Deleted successfully")
        refetch() // Refresh the company list
      } else {
        setLoading(false)
        toast.warning(res?.message || "Company associated to contact")
      }
    } catch (err) {
      //  Close popup even on error
      setLoading(false)
      setConfirmDeleteId(null)
      toast.error(err.message || "Delete error")
    }
  }

  const renderCompanyRow = (company, index) => {
    let userPhone = [],
      userEmail = []
    try {
      userPhone = company.user_phone ? JSON.parse(company.user_phone) : []
      userEmail = company.user_email ? JSON.parse(company.user_email) : []
    } catch (e) { }
    const primaryPhone =
      userPhone[0]?.country_code + " " + userPhone[0]?.phone || company.phone
    const primaryEmail = userEmail[0]?.email || company.email
    return {
      primaryPhone,
      primaryEmail,
    }
  }

  // export data function and states
  const handlePageChange = (selectedItem) => {
    setActiveOffset(selectedItem.selected)
  }
  // edit handler for filter heading
  const handleFilterEdit = async () => {
    try {
      if (editValue === "") return
      if (filterData === null) return
      const updatePayload = {
        filter_id: filterData.id,
        card_name: editValue,
      }
      const res = await PostRequest(
        "company/updateFilterName",
        updatePayload,
        false,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      )
    } catch (error) {
      toast.error("Error Updating Filter")
    }
  }
  // delete handler for filter delete
  const handleFilterDelete = async () => {
    setLoading(true)
    try {
      if (filterData === null) return
      const res = await DeleteRequest(
        `company/deleteFilter/${filterData.id}`,
        { headers },
        { customer, setCustomer, rf: headers.Authentication, navigate }
      )
      if (res.status === "fail") {
        toast.error(res.message)
        return
      }
      if (res.success === false) {
        toast.error("Error Deleting Filter")
      }
      setLoading(true)
      setFilterDropdown(false)
      setFilterDelete(false)
      setRefetchCall(!refetchCall)
      setHeading("All Companies")
      localStorage.setItem("last_heading", "All Companies")
      toast.success(res.message)
    } catch (error) {
      setLoading(true)
      toast.error("Error Deleting Filter")
    }
  }
  // for exporting data in csv formatƒ
  const exportFieldOptions = [
    { id: "company_no", label: "Company No." },
    { id: "company_name", label: "Company Name" },
    { id: "website", label: "Website" },
    { id: "industry", label: "Industry" },
    { id: "business_type", label: "Buisness Type" },
    { id: "employee_size", label: "Employee Size" },
    { id: "owner", label: "Owner" },
    { id: "email", label: "Email" },
    { id: "phone", label: "Phone" },
    { id: "timezone", label: "Timezone" },
    { id: "address", label: "Address" },
    { id: "country", label: "Country" },
    { id: "state", label: "State" },
    { id: "city", label: "City" },
    { id: "zipcode", label: "Zipcode" },
    { id: "about", label: "About" },
    { id: "facebook", label: "Facebook" },
    { id: "twitter", label: "Twitter" },
    { id: "linkedin", label: "Linkedin" },
    { id: "instagram", label: "Instagram" },
    { id: "rating", label: "Rating" },
    { id: "created_at", label: "Created At" },
  ]

  const companyImportFields = [
    // { id: "company_no", label: "Company No.", required: true },
    { id: "company_name", label: "Company Name", required: true },
    { id: "website", label: "Website", required: false },
    { id: "industry", label: "Industry", required: true },
    { id: "business_type", label: "Buisness Type", required: false },
    { id: "owner", label: "Owner", required: true },
    { id: "employee_size", label: "Employee Size", required: false },
    { id: "email", label: "Email", required: true },
    { id: "phone", label: "Phone", required: true },
    { id: "address", label: "Address", required: false },
    { id: "country", label: "Country", required: true },
    { id: "state", label: "State", required: true },
    { id: "city", label: "City", required: true },
    { id: "zipcode", label: "Zipcode", required: false },
    { id: "about", label: "About", required: false },
    { id: "facebook", label: "Facebook", required: false },
    { id: "twitter", label: "Twitter", required: false },
    { id: "linkedin", label: "Linkedin", required: false },
    { id: "instagram", label: "Instagram", required: false },
    { id: "rating", label: "Rating", required: false },
  ]
  const [exportFields, setExportFields] = useState(exportFieldOptions)
  const handleExportFieldChange = (col) => {
    const exists = exportFields?.some((c) => c.id === col.id)

    if (exists) {
      const updateFields = exportFields.filter((c) => c.id !== col.id)

      // Prevent unchecking all - keep at least one field selected
      if (updateFields?.length === 0) {
        return // Don't allow unchecking the last field
      }
      setExportFields(updateFields)
    } else {
      setExportFields((prev) => [...prev, col])
    }
  }

  const renderTableHeaders = () => {
    return (
      <tr style={{ textAlign: "start" }}>
        <th>#</th>

        {columns?.map((label) => {
          const col = columnOptions.find(c => c.label === label);
          if (!col) return null;

          return (
            <th key={col.id}>
              {col.label}{" "}
              <i
                className="fa-solid fa-sort"
                style={{ fontSize: "0.6rem" }}
              ></i>
            </th>
          );
        })}

        <th
          className="lastactionTd"
          id="lastactionTh"
          style={styles.lastdStyle}
        ></th>
      </tr>
    );
  };

  const renderTableBody = () => {
    return (
      <>
        {dataToDisplay.map((company, index) => {
          const { primaryEmail } = renderCompanyRow(company, index)
          return (
            <tr
              key={company.id}
              style={{ marginTop: "10px", marginBottom: "10px" }}
              className={String(company.id) === String(highlightId) ? "blink-row" : ""}
            >
              <td>{index + 1 + limit * activeOffset}</td>
              {columns?.map((label) => {
                const col = columnOptions.find(c => c.label === label);
                if (!col) return null;

                return (
                  <td key={col.id} style={getColumnStyle(col.id)}>
                    {getColumnContent(company, col.id, index)}
                  </td>
                );
              })}
              <td
                className="lastactionTd"
                style={{
                  ...styles.lastdStyle,
                  zIndex: openRow === company.id ? 11 : "auto",
                }}
              >
                <div className="endTdDiv">
                  <Dropdown
                    as="div"
                    className="dropdownsWithoutToggle"
                    onToggle={(isOpen) =>
                      setOpenRow(isOpen ? company.id : null)
                    }
                  >
                    <Dropdown.Toggle as={Nav.Link} className="header-link">
                      <FontAwesomeIcon
                        icon={faEllipsisVertical}
                        style={{
                          fontSize: "15px",
                          width: "20px",
                          color: "#536485",
                        }}
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      align={"end"}
                      style={{
                        width: "8rem",
                        inset: "0px auto auto 0px",
                        boxShadow: "rgb(215, 215, 215) 0px 0px 15px",
                        position: "absolute",
                        marginTop: "-22px",
                        marginRight: "40px",
                        minWidth: "3rem",
                      }}
                    >
                      <Dropdown.Item
                        style={{
                          fontSize: "12px",
                          padding: "4px 21px",
                        }}
                        className="d-flex align-items-center btn"
                        onClick={() => {
                          if (!companyGrants.isEdit) {
                            toast.warning("You are not authorized for this action!")
                            return
                          }
                          fetchCompanyDetails(company.id)
                        }
                        }
                      >
                        {" "}
                        Edit{" "}
                      </Dropdown.Item>
                      <Dropdown.Item
                        style={{
                          fontSize: "12px",
                          padding: "4px 21px",
                        }}
                        className="d-flex align-items-center btn"
                        onClick={() => {
                          if (!companyGrants.isDelete) {
                            toast.warning("You are not authorized for this action!")
                            return
                          }
                          setConfirmDeleteId(company.id)
                        }
                        }
                      >
                        {" "}
                        Delete{" "}
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </td>
            </tr>
          )
        })}
      </>
    )
  }

  // for calling
  const handleGlobalCallChange = () => {
    setGlobalDiller(false);
    setModuleId(null)
    setCallingTo(null)
  };

  const checkTwilio = async () => {
    if (isCheckingTwilio) return;
    setIsCheckingTwilio(true);
    try {
      const res = await checkTwilioIntegration(customer_id, headers, extras)
      if (res.status === "fail" || res.success === false) {
        setShowTwilioModal(true);
      }
      if (res.status === "success") {
        setGlobalDiller(true);
      }

    } catch (error) {
      console.error(error)
    } finally {
      setIsCheckingTwilio(false);
    }
  }

  // company offcanvas close handler in order to execute certain functions and mutate state of canvas close
  const handleCompanyCanvasClose = () => {
    refetch()
    setShowCompanyDetails(false)
  }

  return (
    <div className="container-fluid d-flex flex-column px-0">
      {/* comapany full heading div */}
      <div
        className="d-flex align-items-center justify-content-between"
        style={{ marginTop: "-50px" }}
      >
        {/* company div */}
        <div className="d-flex justify-content-between align-items-center mb-3 position-relative">
          <h3
            className="mb-0 me-1"
            style={{ fontWeight: 200, fontSize: "22px" }}
          >
            {heading}
          </h3>

          {/* heading filter dropdown */}
          <ManageListDropdown
            heading={heading}
            setHeading={setHeading}
            categories={filterCategories}
            storageKey="company_last_heading"
            module="company"
            setTempFilterData={setTempFilterData}
            onEdit={(c) => setFilterData(c)}
            onDelete={(c) => {
              setFilterData(c)
              setFilterDelete(true)
            }}
            onUpdate={(c) => {
              setFilterData(c)
              handleFilterEdit()
            }}
            staticOptions={companyStaticListOptions}
            filterOffset={filterOffset}
            setFilterOffset={setFilterOffset}
            handleFilterPageChange={handleFilterPageChange}
            filterPageCount={filterPageCount}
            filterLimit={filterLimit}
          />

          {confirmFilterDelete && (
            <DeleteModal
              show={confirmFilterDelete}
              onClose={() => setFilterDelete(false)}
              onConfirm={() => handleFilterDelete(filterData)}
              message="Are you sure you want to delete this item?"
              isLoading={loading}
            ></DeleteModal>
          )}
          <div className="form-check form-switch ms-3">
            <input
              type="checkbox"
              class="form-check-input"
              role="switch"
              checked={showCards} // Changed from !showCards to showCards
              onChange={() => setShowCards(!showCards)}
            />
          </div>
        </div>

        {/* form actions div */}
        <Form
          onSubmit={handleSearch}
          className="d-flex align-items-center pt-4"
        >
          <Row className="mb-4 justify-content-between align-items-center">
            <Col md="auto"></Col>
            <Col
              md={6}
              className="d-flex justify-content-end align-items-center gap-1"
              style={{ height: 35 }}
            >
              <div>
                <i
                  className="fa-solid fa-magnifying-glass"
                  style={{
                    position: "absolute",
                    marginLeft: "13px",
                    fontSize: 12,
                    marginTop: 11,
                  }}
                ></i>
                <input
                  className="form-control"
                  type="text"
                  style={{
                    fontSize: "12px",
                    paddingLeft: "50px",
                    width: "250px",
                    maxHeight: 35,
                  }}
                  onChange={(e) => {
                    setInputSearch(e.target.value)
                    setActiveOffset(0)
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault()
                      setSearch(inputSearch)
                      setActiveOffset(0)
                    }
                  }}
                />
              </div>
              <div
                className="d-flex gap-1 px-2"
                style={{
                  border: "1px solid #7a3a5e69",
                  borderRadius: "3px",
                  background: "#ffffff",
                  padding: "4px 8px",
                  maxHeight: 35,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {/* Card View Button */}
                <Button
                  variant="light"
                  className="p-1 border-0"
                  style={{
                    padding: "3px 5px",
                    borderRadius: "4px",
                    backgroundColor:
                      viewMode === "card" ? "#e8e8e8" : "transparent",
                    transition: "background-color 0.2s ease",
                    minWidth: "32px",
                    maxHeight: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => handleViewChange("card")}
                >
                  <IconLayoutGrid
                    stroke={2}
                    style={{
                      width: "18px",
                      height: "18px",
                      color: "#212121",
                    }}
                  />
                </Button>

                {/* List View Button */}
                <Button
                  variant="light"
                  className="p-1 border-0"
                  style={{
                    padding: "3px 5px",
                    maxHeight: 32,
                    borderRadius: "4px",
                    backgroundColor:
                      viewMode === "table" ? "#e8e8e8" : "transparent",
                    transition: "background-color 0.2s ease",
                    minWidth: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => handleViewChange("table")}
                >
                  <IconListDetails
                    stroke={2}
                    style={{
                      width: "18px",
                      height: "18px",
                      color: "#212121",
                    }}
                  />
                </Button>
              </div>
              {/* advance filtering */}
              <Filter
                canEdit_canDownload={true}
                dropdownOptions={dropdownOptions}
                filterState={filterStates}
                setFilterState={setFilterState}
                filterDropdown={filterDropdown}
                setFilterDropdown={setFilterDropdown}
                setHeading={setHeading}
                subFilter={subFilter}
                customSubFilter={customSubFilter}
                applyQuery={"company/applyFilter"}
                setTempFilterData={setTempFilterData}
                filterEndpoint={"company/filterQuery"}
                view={viewMode == "table" ? "list" : "card"}
              ></Filter>
              {/* field filter dropdown */}

              {/* Gear icon dropdown with drag and drop */}
              <ColumnConfigurator
                columnOptions={columnOptions}
                columns={columns}
                setColumns={setColumns}
                storageKey="companyColumns"
                visibleKey="visibleCompanyColumns"
              />
              <Dropdown
                as="div"
                className="dropdownsWithoutToggle"
                style={{ zIndex: 101 }}
              >
                <Dropdown.Toggle as={Nav.Link} className="header-link">
                  <button
                    className="py-2 w-[30px] d-flex gap-1 rounded-1 btn-default-outline justify-content-center"
                    style={{
                      fontSize: "1rem",
                      alignItems: "center",
                      height: "35px",
                      width: "2.5rem",
                    }}
                  >
                    {" "}
                    <FontAwesomeIcon
                      style={{
                        width: "15px",
                        height: "15px",
                      }}
                      icon={faEllipsisVertical}
                    />
                  </button>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="defaultDropdown dropdown-menu-end "
                  style={{
                    width: "11rem",
                    padding: "12px 0px",
                    right: "3.4rem",
                  }}
                >
                  <Dropdown.Item
                    onClick={() => {
                      if (!companyGrants.isImport) {
                        toast.warning("You are not authorized for this action!")
                        return
                      }
                      navigate("/importdata", {
                        state: {
                          module_name: "company",
                          fieldData: [{
                            title: "General Fields",
                            fields: companyImportFields.map(c => c)
                          }]
                        }
                      })
                    }}
                    href="#" className="d-flex align-items-center">
                    <FontAwesomeIcon
                      icon={faFileImport}
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "9px",
                        color: "#5e5f60",
                      }}
                    />{" "}
                    Import Data
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      if (!companyGrants.isExport) {
                        toast.warning("You are not authorized for this action!")
                        return
                      }
                      setExportPop(true)
                    }}
                    className="d-flex align-items-center"
                  >
                    <FontAwesomeIcon
                      icon={faFileExport}
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "9px",
                        color: "#5e5f60",
                      }}
                    />{" "}
                    Export Data
                  </Dropdown.Item>
                  {exportPop && (
                    <ExportDataPopup
                      exportPop={exportPop}
                      setExportPop={setExportPop}
                      heading={"Export Company Data"}
                      handleClose={() => setExportPop(false)}
                      exportData={exportFields.map((c) => c.id)}
                      module_name="company"
                      handleFieldChange={handleExportFieldChange}
                      fields={exportFieldOptions}
                      selectedFields={exportFields}
                    />
                  )}
                </Dropdown.Menu>
              </Dropdown>


              <Button
                type="button"
                className="btn btn-default"
                style={{
                  height: "34px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                onClick={() => {
                  if (!companyGrants.isCreate) {
                    toast.warning("You are not authorized for this action!")
                    return
                  }
                  setShowCreateCompany(true)
                }
                }
              >
                <FontAwesomeIcon icon={faPlus} className="pe-1" /> Add
              </Button>
            </Col>
          </Row>
        </Form>
      </div>


      {!showCards && cardData && (
        <div className="row  mb-0 mt-3 w-100 ms-0">
          <div
            className="col-xxl-3 col-lg-3 col-md-6 ps-0 newCardsHeading"
            style={{ height: "88%", zIndex: 0 }}
          >
            <div className="card custom-card overflow-hidden" style={{ height: "160px" }}>
              <div className="card-body pt-2 w-100 pb-2 ps-2">
                <div className="d-flex align-items-top justify-content-between">
                  <div>
                    <span
                      className="avatar avatar-md avatar-rounded"
                      style={{ background: "#3d9fd7" }}
                    >
                      <i className="ti ti-briefcase fs-16"></i>
                    </span>
                  </div>
                  <div className="flex-fill ms-3">
                    <div className="flex-wrap">
                      <div>
                        <a
                          className="text-warning"
                          href="##"
                        >
                          <p
                            className=" mb-0"
                            style={{ fontWeight: 200, color: "#3d9fd7" }}
                          >
                            Companies created by me
                          </p>
                          <h4
                            className="fw-semibold mt-1 d-flex fs-20 justify-content-between "
                            style={{ color: "black" }}
                          >
                            {cardData?.created_by_me ?? 0}
                            {/* 12,34,449{" "} */}
                            <div
                              id="crm-total-deals"
                              style={{
                                width: 80,
                                height: "auto",
                                minHeight: "35px",
                              }}
                            >
                              <div
                                id="apexchartsn21xcu4d"
                                className="apexcharts-canvas apexchartsn21xcu4d apexcharts-theme-light d-flex justify-content-end align-items-centre"
                                style={{ width: 100, height: 26 }}
                              >
                                <img src={imges} style={{ width: 67 }} />
                              </div>
                            </div>
                          </h4>
                        </a>
                      </div>
                    </div>
                    {/*  */}
                    <div
                      className="d-flex align-items-center justify-content-between mt-1"
                      style={{ lineHeight: 1.2 }}
                    >
                      <div>
                        <p className="mb-0 text-success fw-semibold">
                          {/* 1356  */}
                          {cardData?.currentMonth_byMe ?? 0}
                        </p>
                        <span className="text-muted op-7 fs-11">
                          Total Collection
                        </span>
                      </div>
                      <div className="text-end">
                        <p className="mb-0 text-success fw-semibold">
                          {/* 784  */}
                          {cardData?.lastMonth_byMe ?? 0}
                        </p>
                        <span className="text-muted op-7 fs-11">
                          Last Month
                        </span>
                      </div>
                    </div>
                    {/*  */}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="col-xxl-3 col-lg-3 col-md-6 ps-0 newCardsHeading"
            style={{ height: "88%", zIndex: 0 }}
          >
            <div className="card custom-card overflow-hidden" style={{ height: "160px" }}>
              <div className="card-body pt-2 w-100 pb-2 ps-2">
                <div className="d-flex align-items-top justify-content-between">
                  <div>
                    <span className="avatar avatar-md avatar-rounded bg-secondary">
                      <i className="ti ti-wallet fs-16"></i>
                    </span>
                  </div>
                  <div className="flex-fill ms-3">
                    <div className="flex-wrap">
                      <div>
                        <a
                          className="text-warning"
                          href="##"
                        >
                          <p
                            className="text-secondary mb-0"
                            style={{ fontWeight: 200 }}
                          >
                            All Companies
                          </p>
                          <h4
                            className="fw-semibold mt-1 d-flex fs-20 justify-content-between "
                            style={{ color: "black" }}
                          >
                            {/* 12,34,449{" "} */}
                            {cardData?.all_company ?? 0}
                            <div
                              id="crm-total-deals"
                              style={{
                                width: 80,
                                height: "auto",
                                minHeight: "35px",
                              }}
                            >
                              <div
                                id="apexchartsn21xcu4d"
                                className="apexcharts-canvas apexchartsn21xcu4d apexcharts-theme-light d-flex justify-content-end align-items-centre"
                                style={{ width: 100, height: 26 }}
                              >
                                <img src={imges} style={{ width: 67 }} />
                              </div>
                            </div>
                          </h4>
                        </a>
                      </div>
                    </div>
                    <div
                      className="d-flex align-items-center justify-content-between mt-1"
                      style={{ lineHeight: 1.2 }}
                    >
                      <div>
                        <p className="mb-0 text-success fw-semibold">
                          {cardData?.currentMonth ?? 0}
                        </p>
                        <span className="text-muted op-7 fs-11">
                          Total Collection
                        </span>
                      </div>
                      <div className="text-end">
                        <p className="mb-0 text-success fw-semibold">
                          {/* 784 */}
                          {cardData?.lastMonth ?? 0}
                        </p>
                        <span className="text-muted op-7 fs-11">
                          Last Month
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div className="col-xxl-6 col-lg-6 col-md-6 ps-0 pb-0 newCardsHeading">
            <div className="card custom-card overflow-hidden p-0" style={{ height: "160px" }}>
              <div className="card-body w-100" style={{ height: "88%", zIndex: 0 }}>

                {/* HEADER (ROW) */}
                <div className="d-flex align-items-center">
                  <span
                    className="avatar avatar-md avatar-rounded"
                    style={{ background: "#3faa5f" }}
                  >
                    <i className="ti ti-briefcase fs-16"></i>
                  </span>

                  <p
                    className="mb-0 ms-3"
                    style={{ fontWeight: 200, color: "#3faa5f" }}
                  >
                    Companies from top 10 cities
                  </p>
                </div>

                <div style={{ width: "100%", height: 95 }}>
                  {top10CitiesData?.length ? (
                    <ResponsiveContainer width="100%" height="110%">
                      <ComposedChart
                        data={top10CitiesData}
                        margin={{ top: 10, right: 20, left: 0, bottom: 30 }}
                      >
                        <defs>
                          <linearGradient id="cityGradient" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#865adf" stopOpacity={0.8} />
                            <stop offset="95%" stopColor="#865adf" stopOpacity={0.1} />
                          </linearGradient>
                        </defs>

                        <XAxis
                          dataKey="city"
                          tick={{ fontSize: 10, fill: "#888" }}
                          interval={0}
                          angle={-30}
                          textAnchor="end"
                          axisLine={false}
                          tickLine={false}
                        />

                        <YAxis
                          allowDecimals={false}
                          tick={{ fontSize: 10, fill: "#888" }}
                          axisLine={false}
                          tickLine={false}
                        // domain={[0, dataMax => dataMax + 2]}
                        />

                        <CartesianGrid
                          strokeDasharray="3 3"
                          vertical={false}
                          stroke="#f0f0f0"
                        />


                        <RechartTooltip
                          cursor={{ stroke: "#e5e7eb", strokeWidth: 1 }}
                          contentStyle={{
                            borderRadius: 8,
                            border: "1px solid #e0e0e0",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                            fontSize: 12,
                          }}
                        />

                        {/* Area with gradient - render first so line appears on top */}
                        <Area
                          type="monotone"
                          dataKey="companies"
                          fill="url(#cityGradient)"
                          stroke="none"
                          fillOpacity={1}
                          tooltipType="none"
                        />

                        {/* Line with larger, more visible dots */}
                        <Line
                          type="monotone"
                          dataKey="companies"
                          stroke="#865adf"
                          strokeWidth={1}
                          dot={{
                            r: 2,
                            fill: "#865adf",

                          }}
                          activeDot={{
                            r: 6,
                            fill: "#865adf",
                            stroke: "#fff",
                            strokeWidth: 3,
                            style: { cursor: 'pointer' }
                          }}
                          animationDuration={900}
                        />
                      </ComposedChart>
                    </ResponsiveContainer>
                  ) : (
                    <p className="text-muted fs-12">No data available</p>
                  )}
                </div>


              </div>
            </div>
          </div>

        </div>
      )}

      {
        companyGrants.isView ?
          viewMode === "card" ? (
            <>
              <hr />
              {isLoading ? <CompanyCardSkeletonShimmer /> :
                <CompanyCardView
                  dataToDisplay={dataToDisplay}
                  baseURL={baseURL}
                  profile={profile}
                  pageCount={pageCount > 1 ? pageCount : 0}
                  limit={limit}
                  setLimit={setLimit}
                  offset={activeOffset}
                  handlePageChange={handlePageChange}
                  setSelectedCompanyId={setSelectedCompanyId}
                  setShowCompanyDetails={setShowCompanyDetails}
                  fetchCompanyDetails={fetchCompanyDetails}
                  setConfirmDeleteId={setConfirmDeleteId}
                  renderCompanyRow={renderCompanyRow}
                  setOffset={setActiveOffset}
                />
              }
            </>
          )
            :
            (
              <Container
                fluid
                style={{
                  fontFamily: "'Poppins', sans-serif",
                  height: "calc(100vh - 11rem)",  // 14 rem for pagination seperate
                  backgroundColor: "white",
                  padding: 0,
                  animation: "cardEntry 1s ease-out forwards"
                }}
                className=" p-0"
              >
                <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", }}>

                  <div
                    className="listStyleForContact container-table"
                    style={{
                      flex: dataToDisplay?.length > 8 ? 1 : "auto",
                      overflow: "auto",
                      width: "100%",
                      overflowX: "auto",
                      maxHeight: dataToDisplay?.length > 8 ? "100%" : "auto",
                      scrollbarWidth: "thin"
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.scrollbarColor = "#e0e0e0 white"
                    }}
                  >
                    <Table
                      style={{
                        width: "100%",
                        tableLayout: "auto",
                        backgroundColor: "white",
                        marginBottom: "0px",
                        borderCollapse: "separate",
                        borderSpacing: "0px",
                      }}
                    >
                      <thead style={{ zIndex: 10 }}>
                        {renderTableHeaders()}
                      </thead>
                      {isLoading ? <TableSkeleton rowCount={6} columnCount={columns.length} /> : <>
                        <tbody style={{ textAlign: "start" }}>
                          {
                            hasDataToDisplay ?
                              renderTableBody() :
                              (
                                <td
                                  colSpan="14"
                                  style={{ textAlign: "center", color: "gray" }}
                                >
                                  <div
                                    class="d-flex justify-content-center align-items-center"
                                    style={{ position: "absolute", left: " 42%" }}
                                  >
                                    <img
                                      src={nodata}
                                      alt=""
                                      style={{ width: "17rem", marginTop: "0" }}
                                    />
                                  </div>
                                </td>
                              )
                          }
                          {dataToDisplay?.length > 9 && (
                            <tr
                              className="no-hover-row"
                              style={{
                                backgroundColor: "#ffffff",
                                marginTop: "0px !important",
                                marginBottom: "0px !important",
                              }}
                            >
                              <td colSpan={13}>
                                <div style={{ padding: 0 }}>
                                  <div
                                    className="d-flex justify-content-between align-items-center gap-2 mt-0"
                                    style={{
                                      padding: "0.5rem 0",
                                    }}
                                  >
                                    <div className="pagination-left">
                                      <p
                                        className="mb-0"
                                        style={{
                                          fontSize: "14px",
                                          paddingRight: "10rem",
                                        }}
                                      >
                                        Showing {activeOffset + 1} of{" "}
                                        {pageCount !== 0 ? pageCount : pageCount + 1}
                                      </p>
                                    </div>
                                    <div className="pagination-right d-flex gap-2 align-items-center">
                                      <select
                                        style={{ minWidth: "78px", height: "2.3rem" }}
                                        onChange={(e) => {
                                          setLimit(Number(e.target.value))
                                          setActiveOffset(0)
                                        }}
                                        id="limit"
                                        className="form-control form-select"
                                      >
                                        <option value={25}>25</option>
                                        <option value={100}>100</option>
                                        <option value={200}>200</option>
                                        <option value={300}>300</option>
                                      </select>
                                      <div className="d-flex align-items-center gap-3">
                                        <Pagination
                                          offset={activeOffset}
                                          setOffset={setActiveOffset}
                                          handlePageChange={handlePageChange}
                                          pageCount={pageCount}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </>}
                    </Table>
                  </div>
                </div>
                {dataToDisplay?.length <= 9 && (
                  <div
                    style={{
                      padding: "0.5rem 0",
                      backgroundColor: "white",
                      borderTop: "1px solid #e0e0e0",
                      overflowX: "auto",
                      width: "100%",
                    }}
                  >
                    <div className="d-flex justify-content-between align-items-center gap-2">
                      <div className="pagination-left">
                        <p className="mb-0" style={{ fontSize: "14px" }}>
                          Showing {activeOffset + 1} of{" "}
                          {pageCount !== 0 ? pageCount : pageCount + 1}
                        </p>
                      </div>
                      <div className="pagination-right d-flex gap-2 align-items-center">
                        <select
                          style={{ minWidth: "78px", height: "2.3rem" }}
                          onChange={(e) => {
                            setLimit(Number(e.target.value))
                            setActiveOffset(0)
                          }}
                          id="limit"
                          className="form-control form-select"
                        >
                          <option value={25}>25</option>
                          <option value={100}>100</option>
                          <option value={200}>200</option>
                          <option value={300}>300</option>
                        </select>
                        <div className="d-flex align-items-center gap-3">
                          <Pagination
                            offset={activeOffset}
                            setOffset={setActiveOffset}
                            handlePageChange={handlePageChange}
                            pageCount={pageCount}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </Container>
            )
          :
          <AuthorizationCard></AuthorizationCard>
      }

      {/* Common Modals outside of loops */}
      {confirmDeleteId && (
        <DeleteModal
          show={true}
          onConfirm={() => handleDeleteCompany(confirmDeleteId)}
          onClose={() => setConfirmDeleteId(null)}
          isLoading={loading}
          companyName={
            dataToDisplay.find((c) => c.id === confirmDeleteId)?.company_name ||
            ""
          }
          message={"Are you sure to permanent delete this company !!"}
        />
      )}

      {globalDiller && (
        <GlobalCallModal
          isOpen={globalDiller}
          customerId={customer_id}
          loginUserId={customer?.customer_details?.id}
          phoneNumber={callingTo}
          onClose={handleGlobalCallChange}
          module_name={"company"}
          module_id={module_id}
        />
      )}

      {/* {twilio modal} */}
      {showtwilioModal && (
        <TwilioIntegrationForm
          isOpen={showtwilioModal}
          onClose={() => setShowTwilioModal(false)}
        />
      )}

      {showOffcanvas && (
        <EditCompanyOffcanvas
          show={true}
          company_data={companyData}
          isOwnerSame={isOwnerSame}
          setShow={() => setShowOffcanvas(false)}
          fetchData={refetch}
        />
      )}

      {showCompanyDetails && (
        <CompanyDetails
          show={showCompanyDetails}
          id={selectedCompanyId}
          allCompanies={dataToDisplay}
          setShowCompanyDetails={setShowCompanyDetails}
          onCanvasClose={handleCompanyCanvasClose}
        />
      )}
    </div>
  )
}
const styles = {
  lastdStyle: {
    padding: "0 !important",
  },


}
